export default __webpack_public_path__ + "static/media/campaignmonitor.e2080bde.png";